// extracted by mini-css-extract-plugin
export default {"infoBox":"styles_infoBox__3nsdh","infoBoxItem":"styles_infoBoxItem__91gZZ","infoBoxIcon":"styles_infoBoxIcon__QCP2V"};